export const INVOICE_PREVIEW_APPEARANCE_PANEL_WIDTH = 320
